export default __webpack_public_path__ + "static/media/mana19.2376e1ea.svg";